import apiClient from './apiClient';

export const customerService = {
    // Get all customers
    getAllCustomers: async (params = {}) => {
        try {
            const response = await apiClient.get('/customers', { params });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get single customer
    getCustomer: async (id) => {
        try {
            const response = await apiClient.get(`/customers/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Create new customer
    createCustomer: async (customerData) => {
        try {
            const response = await apiClient.post('/customers', customerData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update customer
    updateCustomer: async (id, customerData) => {
        try {
            const response = await apiClient.put(`/customers/${id}`, customerData);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete customer
    deleteCustomer: async (id) => {
        try {
            const response = await apiClient.delete(`/customers/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get customer statistics
    getCustomerStats: async () => {
        try {
            const response = await apiClient.get('/customers-data/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get next customer code
    getNextCustomerCode: async () => {
        try {
            const response = await apiClient.get('/customers/next-code');
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // One tariff sheet per package assigned to this customer, priced net of
    // their discounts. Unrestricted customers get every priced package.
    getTariff: async (id) => {
        try {
            const response = await apiClient.get(`/customers/${id}/tariff`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
}; 